// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MessageTwoToneSvg from "@fishx/icons-svg/es/asn/MessageTwoTone";
import FishxIcon from '../components/FishxIcon';

var MessageTwoTone = function MessageTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MessageTwoToneSvg
  }));
};

MessageTwoTone.displayName = 'MessageTwoTone';
export default React.forwardRef(MessageTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MessageTwoTone.js
// module id = 3136
// module chunks = 0